// config/agingTableColumns.ts

import { CustomColumn } from "../../../../types/customColumn";
import { formatCurrency } from "../../../../utils/formatCurrency";

export interface AgingTableRow {
  customerId: number;
  customerName: string;
  currentAmount: number;
  days30: number;
  days60: number;
  days90: number;
  days90Plus: number;
  totalAmount: number;
}

export const agingTableColumns: CustomColumn<AgingTableRow>[] = [
  /**
   * 👤 Cliente
   */
  {
    Header: "Cliente",
    accessor: "customerName",
    customCell: ({ row }) => (
      <div className="min-w-[220px]">
        <div className="font-medium text-black dark:text-white">
          {row.original.customerName || "—"}
        </div>
      </div>
    ),
  },

  /**
   * 💚 Corriente
   */
  {
    Header: "Corriente",
    accessor: "currentAmount",
    customCell: ({ value }) => (
      <span className="font-medium text-meta-3">
        ${formatCurrency(value || 0)}
      </span>
    ),
  },

  /**
   * 🟡 1 - 30 días
   */
  {
    Header: "1 - 30 días",
    accessor: "days30",
    customCell: ({ value }) => (
      <span className="font-medium text-warning">
        ${formatCurrency(value || 0)}
      </span>
    ),
  },

  /**
   * 🟠 31 - 60 días
   */
  {
    Header: "31 - 60 días",
    accessor: "days60",
    customCell: ({ value }) => (
      <span className="font-medium text-warning">
        ${formatCurrency(value || 0)}
      </span>
    ),
  },

  /**
   * 🔴 61 - 90 días
   */
  {
    Header: "61 - 90 días",
    accessor: "days90",
    customCell: ({ value }) => (
      <span className="font-medium text-danger">
        ${formatCurrency(value || 0)}
      </span>
    ),
  },

  /**
   * 🚨 +90 días
   */
  {
    Header: "+90 días",
    accessor: "days90Plus",
    customCell: ({ value }) => (
      <span className="font-semibold text-danger">
        ${formatCurrency(value || 0)}
      </span>
    ),
  },

  /**
   * 💰 Total
   */
  {
    Header: "Total",
    accessor: "totalAmount",
    customCell: ({ value }) => (
      <span className="font-bold text-primary">
        ${formatCurrency(value || 0)}
      </span>
    ),
  },
];